/* global $: false */

const duration = 300

export const initMobileMenu = ({ toggleSel, menuSel }) => {
  const $toggle = $(toggleSel)
  const $menu = $(menuSel)
  let animating = false
  let shown = false
  $toggle.on('click', () => {
    if (!animating) {
      animating = true
      if (shown) {
        $menu.animate({
          opacity: 0
        }, {
          duration,
          complete: () => {
            $menu.hide()
            shown = false
            animating = false
          }
        })
      } else {
        $menu.css('opacity', 0)
        $menu.show()
        $menu.animate({
          opacity: 1
        }, {
          duration,
          complete: () => {
            shown = true
            animating = false
          }
        })
      }
    }
  })
}
